import {useState} from 'react';
import {maxLength, requiredRules} from '@Components/customHooks/ErrorFormValidate/ErrorFormValidate';
import useErrorForm from '@Components/customHooks/useErrorForm';
import UserAuthRequest from '@Requests/UserAuthRequest';
import useTrigger from '@Components/customHooks/useTrigger';
import { navigateTo } from '@Services/navigation';

const UseLoginModel = () => {
	const [ model ] = useState(new UserAuthRequest());
	const [ loadData, setLoadData ] = useTrigger(true);
	
	const {
		clearError,
		setErrorModel,
		validateForm,
		checkErrorClass,
		getErrors,
		getError,
		setError
	} = useErrorForm({
		email: [requiredRules, maxLength(129)],
		password: [requiredRules, ],
	});
	
	const loginRequest = async (data = {}, login = () => {}) => {
		if (validateForm(data)) {
			try {
				setLoadData(false);
				
				const response = await model
					.login(data)
					.get();
				if(response.data.token) {
					login(response.data.token, () => {
						navigateTo('transactions');
					});
				}
			} catch (e) {
				setError('errorLogin', e?.data?.message);
				setErrorModel(e?.data?.errors);
			} finally {
				setLoadData(true);
			}
		}
	};
	
	return {
		loginRequest,
		loadData,
		clearError,
		checkErrorClass,
		getErrors,
		getError,
	};
};

export default UseLoginModel;